import React from 'react';

const Footer = () => (
  <footer style={{ background: '#001f3f', color: 'white', textAlign: 'center', padding: '1rem' }}>
    <p>&copy; 2025 Servicios Estrategicos Integrales de Ingeniería Salvadoreños (SEINS). Todos los derechos reservados.</p>
  </footer>
);

export default Footer;
